import '../../CMSContent/index.js';
import '../../Div/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../Div/Div.js';
import { CMSContent } from '../../CMSContent/CMSContent.js';
const BlockEmbeddedEntry = ({
  defaultSpacingTop,
  additionalProps
} = {}) => function embeddedEntry(node) {
  return /*#__PURE__*/jsx(Div, {
    display: "block",
    spacingTop: defaultSpacingTop,
    children: /*#__PURE__*/jsx(CMSContent, {
      content: node?.data?.target,
      additionalProps: additionalProps
    })
  });
};
export { BlockEmbeddedEntry };
//# sourceMappingURL=BlockEmbeddedEntry.js.map
